// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WriteReview-root-izHT1 {
  padding-left: 20px;
  padding-right: 20px;
}

.WriteReview-container-pMlkz {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-content-width);
}`, "",{"version":3,"sources":["webpack://./src/routes/writeReview/WriteReview.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-content-width);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `WriteReview-root-izHT1`,
	"container": `WriteReview-container-pMlkz`
};
module.exports = ___CSS_LOADER_EXPORT___;
